import React, { useEffect, useState } from 'react';
import { Button, DatePicker, Divider, Form, Input, message, Modal } from 'antd';
import locale from 'antd/es/date-picker/locale/es_ES';
import seguridadProvider from '../../../services/seguridadProvider';
import { irEleccion } from '../../../utils/navegar-eleccion';
import { IUsuarioEleccion } from '../../../interfaces/elecciones/usuario';
import { DownOutlined } from '@ant-design/icons';

const LoginElecciones = () => {
  console.info('inicio...', {});

  const [usuario, setusuario] = useState<IUsuarioEleccion>();

  const [form] = Form.useForm();
  useEffect(() => {
    console.info('eff');
  }, []);

  const layout = {
    labelCol: {
      span: 8
    },
    wrapperCol: {
      span: 8
    }
  };

  const modalContent = (text) => {
    return (
      <div>
        <p>{text}</p>
      </div>
    );
  };

  const [mostrarcip, setmostrarcip] = useState(false);

  const onFinish = async (val) => {
    setcargando(true);
    const regex = /^[0-9]*$/;
    const onlyNumbers = regex.test(val.cip);
    if (!onlyNumbers || val.cip.length !== 4) {
      Modal.error({
        title: 'CIP',
        content: modalContent('Tiene que ser 4 dígitos numéricos')
      });
      setcargando(false);
      return;
    }

    seguridadProvider
      .validarLoginElecciones(val.dni, val.fecha.format('L'), val.cip)
      .then((response) => {
        form.resetFields();
        if (response) {
          Modal.confirm({
            title: 'GESSOMA',
            content: modalContent('Sus datos fueron validados correctamente'),
            okText: 'Iniciar elección',
            cancelText: 'Cerrar',
            onCancel: () => localStorage.removeItem('token'),
            onOk: () => irEleccion({ tipo: null })
          });
        } else {
          Modal.error({
            title: 'GESSOMA',
            content: modalContent('Ocurrio un error al validar su información')
          });
        }
        setcargando(false);
      })
      .catch((err) => {
        if (err.request.status === 500) message.error(err.request.response);
        if (err.request.status === 401)
          message.warning(
            'Aun no se encuentra disponible el proceso o sus datos son incorrectos.!',
            10
          );
        form.resetFields();
        setcargando(false);
      });

    // if (mostrarcip) {
    //   if(val.cip === usuario.cip){
    //
    //   }else{
    //     message.warning("El codigo CIP no es correcto.");
    //   }
    // } else {
    //   const res = await seguridadProvider.validarCip(val.dni, val.fecha.format('L'));
    //   if (res != undefined) {
    //     setusuario(res);
    //     let opcionesCip = [];
    //     for (let i = 0; i < 5; i++) {
    //       const res = Math.random().toFixed(length).split('.')[1];
    //       opcionesCip.push(res);
    //     }
    //     setmostrarcip(true);
    //     opcionesCip[between(0, 4)] = res.cip;
    //     setcips(opcionesCip);
    //   }
    // }
  };

  const [cargando, setcargando] = useState(false);

  return (
    <>
      <Divider orientation='left'>
        ELECCIONES COMITÉ DE INTERVENCIÓN FRENTE AL HOSTIGAMIENTO SEXUAL LABORAL 2026-2028
      </Divider>
      <Form {...layout} form={form} onFinish={onFinish} name='userForm'>
        <Form.Item
          name='dni'
          label='Número de documento'
          rules={[{ required: true, message: 'Número de documento es requerido' }]}
        >
          <Input placeholder={'Ingrese su número de documento.'} />
        </Form.Item>
        <Form.Item
          name='fecha'
          label='Fecha de nacimiento'
          rules={[{ required: true, message: 'Fecha de nacimiento es requerido' }]}
        >
          <DatePicker
            placeholder={'dd/mm/yyyy'}
            style={{ width: '100%' }}
            locale={locale}
            format={'DD/MM/YYYY'}
          />
        </Form.Item>
        <Form.Item
          name='cip'
          tooltip='Ingrese los 4 ultimos digitos de su CIP.'
          label={'CIP'}
          rules={[{ required: true, message: 'Ingrese los ultimo 4 digitos de su CIP' }]}
        >
          <Input placeholder={'Ingrese CIP.'} suffix='Últimos 4 dígitos' />
        </Form.Item>

        {/*<Form.Item name={'fechafinal'} label={'fecha mask'}>*/}
        {/*  <MaskedInput mask='11/11/1111' name='fechafinal1' placeholder='dd/mm/yyyy' />*/}
        {/*</Form.Item>*/}
        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
          <Button loading={cargando} type='primary' htmlType='submit'>
            {mostrarcip ? 'Ingresar' : 'Validar'}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginElecciones;
